<template>
  <div v-if="data.registro != null">
    <div role="tablist">
      <b-card no-body
              class="cardInfo"
              @submit.prevent="cardChanged(clickOcorrenciaObito, 'clickOcorrenciaObito')">
        <button v-b-toggle.ocorrencia_obito
                block
                class="cardInfoBtn"
                type="submit"
                @click="cardChanged(clickOcorrenciaObito, 'clickOcorrenciaObito')">
          Ocorrência de Óbito
          <span v-if="!clickOcorrenciaObito">
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowRight" />
          </span>
          <span v-else>
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowDown" />
          </span>
        </button>

        <b-collapse v-if="clickOcorrenciaObito"
                    id="ocorrencia_obito">
          <div class="mt-3 pl-3 pr-3 pb-2">
            <div class="row">
              <div class="col-2 col-sm-3">
                <label class="resumo-show_label"
                       for="">N° Declaração de Óbito</label>
                <div class="resumo-show_sublabel">
                  {{ data.numero_declaracao_obito || 'Não informado' }}
                </div>
              </div>
              <div class="col-3">
                <label class="resumo-show_label"
                       for="">Data de Nascimento</label>
                <div class="resumo-show_sublabel">
                  {{ data.pessoa.data_nascimento | date }}
                </div>
              </div>
              <div class="col-3">
                <label class="resumo-show_label"
                       for="">Hora do Falecimento</label>
                <div class="resumo-show_sublabel">
                  {{ data.registro.hora_ocorrido || 'Não informado' }}
                </div>
              </div>
            </div>

            <div v-if="data.local"
                 id="local_ocorrencia_obito">
              <div class="row mt-2">
                <div class="col-3">
                  <label class="resumo-show_label"
                         for="">Local da Ocorrência do Óbito</label>
                  <div class="resumo-show_sublabel">
                    {{ data.local ?'Sim' : 'Não informado' }}
                  </div>
                </div>
                <div class="col-3">
                  <label class="resumo-show_label"
                         for="">Nome do Estabelecimento</label>
                  <div class="resumo-show_sublabel">
                    {{ data.local.descricao || 'Não informado' }}
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-2">
                  <label class="resumo-show_label"
                         for="">CEP</label>
                  <div class="resumo-show_sublabel">
                    05405-000
                  </div>
                </div>
                <div class="col-3">
                  <label class="resumo-show_label"
                         for="">Endereço</label>
                  <div class="resumo-show_sublabel">
                    Rua Teodoro Sampaio
                  </div>
                </div>
                <div class="col-2">
                  <label class="resumo-show_label"
                         for="">Número</label>
                  <div class="resumo-show_sublabel">
                    105
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-2">
                  <label class="resumo-show_label"
                         for="">Bairro</label>
                  <div class="resumo-show_sublabel">
                    Pinheiros
                  </div>
                </div>
                <div class="col-2">
                  <label class="resumo-show_label"
                         for="">Cidade</label>
                  <div class="resumo-show_sublabel">
                    São Paulo
                  </div>
                </div>
                <div class="col-2">
                  <label class="resumo-show_label"
                         for="">UF</label>
                  <div class="resumo-show_sublabel">
                    UF
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body
              class="cardInfo"
              @submit.prevent="cardChanged(clickCausaObito, 'clickCausaObito')">
        <button v-b-toggle.causas_obito
                block
                class="cardInfoBtn"
                type="submit"
                @click="cardChanged(clickCausaObito, 'clickCausaObito')">
          Causas de Óbito
          <span v-if="!clickCausaObito">
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowRight" />
          </span>
          <span v-else>
            <icon-svg class="icons--black icon--xxs"
                      icon="arrowDown" />
          </span>
        </button>

        <b-collapse v-if="clickCausaObito"
                    id="causas_obito">
          <div class="mt-3 pb-2">
            <div class="pl-3 pl-3 row">
              <div class="col">
                <div class="row">
                  <div class="col">
                    <label class="resumo-show_label">Tipo de Morte</label>
                    <div class="resumo-show_sublabel">
                      {{ data.tipo_morte || 'Não informado' }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label class="resumo-show_label">
                      Parte I - Causas Antecedentes (Estados mórbidos se existirem, que produziram a causa registrada, mencionando-se em último lugar a causa básica)
                    </label>
                    <div class="resumo-show_sublabel">
                      <div v-if="data.causa_morte_parte_1_a">
                        a) {{ data.causa_morte_parte_1_a }}
                      </div>
                      <div v-if="data.causa_morte_parte_1_b">
                        b) {{ data.causa_morte_parte_1_b }}
                      </div>
                      <div v-if="data.causa_morte_parte_1_c">
                        c) {{ data.causa_morte_parte_1_c }}
                      </div>
                      <div v-if="data.causa_morte_parte_1_d">
                        d) {{ data.causa_morte_parte_1_d }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label class="resumo-show_label">
                      Parte II - Outras condições significativas que contribuíram para a morte, e que não entraram
                    </label>
                    <div class="resumo-show_sublabel">
                      <div v-if="data.causa_morte_parte_2_a">
                        {{ data.causa_morte_parte_2_a }}
                      </div>
                      <div v-if="data.causa_morte_parte_2_b">
                        {{ data.causa_morte_parte_2_b }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body
              class="cardInfo"
              @submit.prevent="cardChanged(clickMedico, 'clickMedico')">
        <button v-b-toggle.medicos_collapse
                block
                class="cardInfoBtn"
                type="submit"
                @click="cardChanged(clickMedico, 'clickMedico')">
          Médico {{ data.medicos.length ? '':'- Não informado' }}
          <span v-if="!!data.medicos.length">
            <span v-if="!clickMedico">
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowRight" />
            </span>
            <span v-else>
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowDown" />
            </span>
          </span>
        </button>

        <b-collapse v-if="clickMedico"
                    id="medicos_collapse">
          <div v-for="medico in data.medicos"
               :key="medico.medico_id"
               class="mt-3 resumo-show_header--shadow">
            <div class="resumo-show_header--blue">
              {{ medico.nome || 'Não informado' }}
            </div>
            <div class="pl-4 pb-1 row">
              <div class="col-10">
                <div class="row">
                  <div class="col">
                    <label class="resumo-show_header--label">CRM</label>
                    <div class="resumo-show_header--sublabel">
                      {{ medico.crm || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Médico Legista?</label>
                    <div class="resumo-show_header--sublabel">
                      {{ medico.legista ? 'Sim' : 'Não' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body
              class="cardInfo"
              @submit.prevent="cardChanged(clickSepultamento, 'clickSepultamento')">
        <button v-b-toggle.sepultamento_collapse
                block
                class="cardInfoBtn"
                type="submit"
                @click="cardChanged(clickSepultamento, 'clickSepultamento')">
          Sepultamento {{ data.sepultamento ? '' : '- Não informado' }}
          <span v-if="data.sepultamento">
            <span v-if="!clickSepultamento">
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowRight" />
            </span>
            <span v-else>
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowDown" />
            </span>
          </span>
        </button>

        <b-collapse v-if="clickSepultamento"
                    id="sepultamento_collapse">
          <div v-if="data.sepultamento"
               class="mt-3 resumo-show_header--shadow">
            <div class="resumo-show_header--blue">
              {{ data.sepultamento.nome || 'Não informado' }}
            </div>
            <div v-if="data.sepultamento.endereco"
                 class="pl-4 pb-1 row">
              <div class="col-10">
                <div class="row">
                  <div class="col">
                    <label class="resumo-show_header--label">CEP</label>
                    <div class="resumo-show_header--sublabel">
                      <span v-if="data.sepultamento && data.sepultamento.endereco">{{ data.sepultamento && data.sepultamento.endereco.cep || 'Não informado' }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Endereço</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.sepultamento && data.sepultamento.endereco.logradouro || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Número</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.sepultamento && data.sepultamento.endereco.numero || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Bairro</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.sepultamento && data.sepultamento.endereco.bairro || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Cidade</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.sepultamento && data.sepultamento.endereco.cidade || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">UF</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.sepultamento && data.sepultamento.endereco.uf || 'Não informado' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="col">
                <label class="resumo-show_header--label">Endereço</label>
                <div class="resumo-show_header--sublabel">
                  {{ 'Não informado' }}
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card no-body
              class="cardInfo"
              @submit.prevent="cardChanged(clickFuneraria, 'clickFuneraria')">
        <button v-b-toggle.funeraria_collapse
                block
                class="cardInfoBtn"
                type="submit"
                @click="cardChanged(clickFuneraria, 'clickFuneraria')">
          Funerária {{ data.funeraria_id ? '' : '- Não informado' }}
          <span v-if="data.funeraria_id">
            <span v-if="!clickFuneraria">
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowRight" />
            </span>
            <span v-else>
              <icon-svg class="icons--black icon--xxs"
                        icon="arrowDown" />
            </span>
          </span>
        </button>

        <b-collapse v-if="clickFuneraria"
                    id="funeraria_collapse">
          <div v-if="data.funeraria_id"
               id="funeraria_1"
               class="mt-3 resumo-show_header--shadow">
            <div class="resumo-show_header--blue">
              {{ data.funeraria.nome || 'Não informado' }}
            </div>
            <div class="pl-4 pb-1 row">
              <div class="col-10">
                <div class="row">
                  <div class="col">
                    <label class="resumo-show_header--label">CEP</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.funeraria.endereco && data.funeraria.endereco.cep || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Endereço</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.funeraria.endereco && data.funeraria.endereco.logradouro || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col-1">
                    <label class="resumo-show_header--label">Número</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.funeraria.endereco && data.funeraria.endereco.numero || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Bairro</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.funeraria.endereco && data.funeraria.endereco.bairro || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col">
                    <label class="resumo-show_header--label">Cidade</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.funeraria.endereco && data.funeraria.endereco.cidade || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col-1">
                    <label class="resumo-show_header--label">UF</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.funeraria.endereco && data.funeraria.endereco.uf || 'Não informado' }}
                    </div>
                  </div>
                  <div class="col-3">
                    <label class="resumo-show_header--label">Número Declaração Funerária</label>
                    <div class="resumo-show_header--sublabel">
                      {{ data.numero_declaracao_funeraria || 'Não informado' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Second",
    props: ["data"],
    data () {
      return {
        clickOcorrenciaObito: false,
        clickCausaObito: false,
        clickMedico: false,
        clickSepultamento: false,
        clickFuneraria: false
      }
    },
    methods: {
      cardChanged (val, name) {
        this[name] = !val
      }
    }
  }
</script>

<style lang="scss" scoped>
  .cardInfo {
    padding-top: 15px;
    border-radius: 0;
    border: 0 solid;
  }

  .cardInfoBtn {
    border-radius: 0;
    border: 0 solid;
    background-color: #eaeaea;
    color: #000;
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    padding: 10px;
    padding-left: 19px;
    margin-bottom: 1px;
  }

  .cardInfoBtn:active,
  .cardInfoBtn:hover {
    outline: 0 !important;
  }
</style>
